<template>
  <footer class="app-footer">
    <span>Abriron Cloud Portal v4.9.6 — 2025</span>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style scoped>
.app-footer {
  text-align: center;
  padding: 14px 16px 18px;
  font-size: 11px;
  color: #94a3b8;
  letter-spacing: .3px;
}
</style>
